import React, {Component} from "react";
// import {get as getDoorVisualisation} from "../../../services/http/doorVisualisationService";
// import {getApiUrl, putWithJWT} from "../../../services/http/httpService";
import "react-table/react-table.css";
import "react-table-hoc-fixed-columns/lib/styles.css";
import {Calendar, momentLocalizer, Views} from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from "moment";
import 'moment/locale/de';
import 'moment/locale/fr';
import 'moment/locale/en-gb';
import MobileLogisticsPlanningDataForm from "./mobileLogisticsPlanningDataForm";
import {get as getLogisticsPlanning} from "../../../services/http/logisticsPlanningService";
import {deleteWithJWT, getApiUrl, postWithJWT, putWithJWT} from "../../../services/http/httpService";
import {dateToString, stringToDate} from "../../../services/dateTimeFormat";
import {getSortedListFromBackendMap} from "../../../services/toolsService";
import CalendarToolbar from "./CalendarToolbar";
import {toast} from "react-toastify";
import MobileLogisticsPlanningCreateCompany from "./mobileLogisticsPlanningCreateCompany";
import MobileLogisticsPlanningAccount from "./mobileLogisticsPlanningAccount";

class MobileLogisticsPlanningListForm extends Component {
    state = {
        dataList: [],
        viewState: "dayPerLoadingPlace",
        date: new Date(),
        showModalDataForm: false,
        showModalAccount: false,
        showModalCreateCompany: false,
        showModalInviteCompany: false,
        companyType: 0,
        searchedCompany: ""
    };
    selectedLogicticsPlanningDbId = 0;
    selectedSlot = null;
    selectedDate = new Date();
    calendarRessourceList = [];

    receiversMap = {};
    receiverList = [];
    vendorsMap = {};
    vendorList = [];
    carriersMap = {};
    carrierList = [];
    ressourcesMap = {};
    ressourceList = [];
    loadingPlacesMap = {};
    loadingPlaceList = [];
    vehicleTypesMap = {};
    vehicleTypeList = [];

    rolesMap = {};

    earliestTime = 6 * 60 + 30;
    latestTime = 17 * 60;

    RECEIVER = 1;
    VENDOR = 2;
    CARRIER = 3;

    componentDidMount = async () => {

        const {viewState} = this.state;

        const now = new Date();
        const today = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate()
        );

        await this.onRefresh(today, viewState, true);
    };

    onRefresh = async (date, viewState, initData, company) => {

        // const {searchedCompany} = this.state;
        const request = await getLogisticsPlanning(
            this.props.credentials,
            getApiUrl() +
            "/" +
            "secClockworkLogisticsPlanning" +
            "?initData=" + initData +
            "&date=" + dateToString(date, "YYYYMMDD") +
            "&viewState=" + viewState +
            "&companyId=" + (company ? company : "")
            )
        ;

        if (initData) {

            this.rolesMap = {...request.data.data.rolesMap};


            this.receiversMap = {...request.data.data.receiversMap};
            this.receiverList = getSortedListFromBackendMap(this.receiversMap, ["name"], ["name"]);

            this.vendorsMap = {...request.data.data.vendorsMap};
            this.vendorList = getSortedListFromBackendMap(this.vendorsMap, ["name"], ["name"]);

            this.carriersMap = {...request.data.data.carriersMap};
            this.carrierList = getSortedListFromBackendMap(this.carriersMap, ["name"], ["name"]);

            this.ressourcesMap = {...request.data.data.ressourcesMap};
            this.ressourceList = getSortedListFromBackendMap(this.ressourcesMap, ["name"], ["name"]);

            this.loadingPlacesMap = {...request.data.data.loadingPlacesMap};
            this.loadingPlaceList = getSortedListFromBackendMap(this.loadingPlacesMap, ["name"], ["name"]);
            this.calendarRessourceList = this.loadingPlaceList.map(loadingPlace => {
                return {
                    id: "" + loadingPlace.dbId,
                    title: loadingPlace.name
                }
            })
            this.vehicleTypesMap = {...request.data.data.vehicleTypesMap};
            this.vehicleTypeList = getSortedListFromBackendMap(this.vehicleTypesMap, ["name"], ["name"]);
        }

        // const calendarList = getSortedListFromBackendMap(request.data.data.logisticsPlanningsMap, ["name"], ["name"]);
        this.createDataList(
            request.data.data.logisticsPlanningList
        );
    };

    onDate = (date, viewState) => {
        this.onRefresh(date, viewState, false)
        this.setState({date, viewState})
    }

    onSearchCompany = (date, viewState, {currentTarget: input}) => {
        this.setState({searchedCompany: input.value});
        this.onRefresh(date, viewState, false, input.value)
    }

    createDataList = (logisticsPlanningList) => {

        const dataList = [];

        for (const record of logisticsPlanningList) {
            dataList.push({
                selectedLogicticsPlanningDbId: record.dbId,
                start: stringToDate(record.start, "YYYYMMDDHHmm"),
                end: stringToDate(record.end, "YYYYMMDDHHmm"),
                title: record.title,
                desc: record.desc,
                resourceId: "" + record.resourceId
            });
        }

        this.setState({dataList});
    };

    onSaveLogisticsPlanning = async (data) => {

        const {date, viewState} = this.state;
        const {credentials} = this.props;

        if (data.dbId === 0) {
            const request = await postWithJWT(
                credentials,
                getApiUrl() + "/secClockworkLogisticsPlanning",
                data
            );
            if (request.data.error) {
                toast.error(
                    "Fehler: " + request.data.errorMessage,
                    {
                        autoClose: 5000
                    }
                );
                return;
            }
        } else {
            const request = await putWithJWT(
                credentials,
                getApiUrl() + "/secClockworkLogisticsPlanning" + "?" +
                "dbId=" + data.dbId,
                {...data}
            );
            if (request.data.error) {
                toast.error(
                    "Fehler: " + request.data.errorMessage,
                    {
                        autoClose: 5000
                    }
                );
                return;
            }
        }

        this.onCloseModal();
        this.onRefresh(date, viewState, false);

    }

    onDeleteLogisticsPlanning = async (data) => {

        const {date, viewState} = this.state;
        const {credentials} = this.props;

        const request = await deleteWithJWT(
            credentials,
            getApiUrl() + "/secClockworkLogisticsPlanning" + "?" +
            "dbId=" + data.dbId
        );

        this.onCloseModal();

        this.onRefresh(date, viewState, false);

    }

    onSaveCreateCompany = async (data) => {

        const {date, companyType} = this.state;
        const {credentials} = this.props;

        const newData = {
            companyType: companyType,
            ...data
        }

        const request = await postWithJWT(
            credentials,
            getApiUrl() + "/secClockworkCreateCompany",
            newData
        );
        if (request.data.error) {
            toast.error(
                "Fehler: " + request.data.errorMessage,
                {
                    autoClose: 5000
                }
            );
            return;
        }

        this.onCloseModal();

    }

    onEditAccount = () => {
        this.onOpenEditAccountModal()
    }

    onCreateReceiver = () => {
        this.onOpenCreateCompanyModal(this.RECEIVER)
    }

    onInviteReceiver = () => {
        this.onOpenInviteCompanyModal(this.RECEIVER)
    }

    onCreateVendor = () => {
        this.onOpenCreateCompanyModal(this.VENDOR)
    }

    onInviteVendor = () => {
        this.onOpenInviteCompanyModal(this.VENDOR)
    }

    onCreateCarrier = () => {
        this.onOpenCreateCompanyModal(this.CARRIER)
    }

    onInviteCarrier = () => {
        this.onOpenInviteCompanyModal(this.CARRIER)
    }


    onOpenDataFormModal = () => {
        this.setState({showModalDataForm: true});
    };

    onOpenEditAccountModal = () => {
        this.setState({showModalAccount: true});
    };

    onOpenCreateCompanyModal = (companyType) => {
        this.setState({showModalCreateCompany: true, companyType});
    };

    onOpenInviteCompanyModal = (companyType) => {
        this.setState({showModalInviteCompany: true, companyType});
    };

    onCloseModal = () => {
        this.setState({
            showModalDataForm: false,
            showModalCreateCompany: false,
            showModalInviteCompany: false,
            showModalAccount: false
        });
    };

    renderEvent = (eventObject) => {
        return (
            <React.Fragment>
                {/*<button onClick={() => {*/}
                {/*    this.onClickEvent(eventObject);*/}
                {/*}}*/}
                {/*>event*/}
                {/*</button>*/}
                <span>
                    <strong>{eventObject.event.title}</strong>
                    {eventObject.event.desc && ':  ' + eventObject.event.desc}
                </span>
            </React.Fragment>
        )
    }
    renderEventAgenda = (agendaObject) => {
        return (
            <React.Fragment>
                {/*<button onClick={() => {*/}
                {/*    this.onClickEventAgenda(agendaObject);*/}
                {/*}}*/}
                {/*>agenda*/}
                {/*</button>*/}
                <span>
                    <em style={{color: 'magenta'}}>{agendaObject.event.title}</em>
                    <p>{agendaObject.event.desc}</p>
                </span>
            </React.Fragment>
        )
    }
    onClickEvent = (eventObject) => {
        // console.log("onClickEvent(): object=", eventObject)
    }

    onClickEventAgenda = (agendaObject) => {
        // console.log("onClickEventAgenda(): object=", agendaObject)
    }

    onSelectSlot = (slot) => {
        const {viewState} = this.state;

        // es wurde der Slot fuer den ganzen Tag ausgewaehlt -> keine Berechtigung

        if (viewState !== "month") {
            if (slot.start === slot.end)
                return

            if (!this.isValidStartTime(slot.start))
                return
            if (!this.isValidEndTime(slot.end))
                return
        }

        this.selectedSlot = {...slot};

        if (viewState === "month") {
            const momentDate = moment(slot.start);
            momentDate.add(6, "hours")
            momentDate.add(30, "minutes")
            this.selectedSlot.start = momentDate.toDate();

            momentDate.add(30, "minutes")
            this.selectedSlot.end = momentDate.toDate();

        }

        this.selectedLogicticsPlanningDbId = 0;
        this.selectedDate = slot.start;
        this.onOpenDataFormModal();

    }

    onSelectEvent = (event) => {

        if (event.selectedLogicticsPlanningDbId > 0) {
            // falls dieses Event bereits exisitert, kann man es auch bearbeiten, obwohl die Zeit vor dem fruehesten Beginn eingetragen ist
            this.selectedLogicticsPlanningDbId = event.selectedLogicticsPlanningDbId;
            this.selectedDate = event.start;
            this.onOpenDataFormModal();
            return;
        }

        if (!this.isValidStartTime(event.start))
            return
        if (!this.isValidEndTime(event.end))
            return

        if (event.selectedLogicticsPlanningDbId == -1) {
            // es wurde ein unauthorisierteres Event auswegaehlt -> keine Berechtigung
            return;
        } else if (event.selectedLogicticsPlanningDbId == -2) {
            // es wurde ein freies Event (-> Slot) ausgewaehlt
            this.selectedSlot = {
                selectedLoadingPlaceDbId: event.resourceId,
                ...event
            };
            this.selectedLogicticsPlanningDbId = -2;
            this.selectedDate = event.start;
            this.onOpenDataFormModal();
        }
    }

    isValidStartTime = (date) => {

        const time = date.getHours() * 60 + date.getMinutes()

        if (time < this.earliestTime)
            return false;
        if (time >= this.latestTime)
            return false;

        return true;

    }

    isValidEndTime = (date) => {

        const time = date.getHours() * 60 + date.getMinutes()

        if (time <= this.earliestTime)
            return false;
        if (time > this.latestTime)
            return false;

        return true;

    }

    onView = (object) => {
        // console.log("onView(): object=", object);
    }

    customDayPropGetter = date => {
        console.log("customDayPropGetter()", date)
        if (date.getDate() === 28 || date.getDate() === 29)
            return {
                className: 'special-day',
                style: {
                    border: 'solid 3px ' + (date.getDate() === 28 ? 'blue' : 'red'),
                },
            }
        else return {}
    }

    customSlotPropGetter = date => {
        console.log("customSlotPropGetter()", date)
        if (date.getDate() === 30 || date.getDate() === 31)
            return {
                className: 'special-day',
                style: {
                    border: 'solid 3px ' + (date.getDate() === 30 ? 'green' : 'yellow'),
                },
            }
        else return {}
    }

    customEventPropGetter = (event, start, end, isSelected) => {
        let newStyle = {
            backgroundColor: (event.selectedLogicticsPlanningDbId === -1 ? "lightcoral" : (event.selectedLogicticsPlanningDbId === -2 ? "lightgreen" : "lightgrey")),
            color: 'black',
            borderRadius: "0px",
            // border: "none"
            // opacity: 0.8,
            // border: '5px',
            // display: 'block'
        };

        if (event.isMine) {
            newStyle.backgroundColor = "lightgreen"
        }

        // funktioniert nicht
        // if (event.isSelected) {
        //     newStyle.backgroundColor = "lightcoral"
        // }

        return {
            className: "",
            style: newStyle
        };
    }

    MODAL_STYLES = {
        // overlay: {
        //     position: "fixed",
        //     top: 20,
        //     left: 0,
        //     right: 0,
        //     bottom: 0,
        //     backgroundColor: "rgba(255, 255, 255, .5)",
        // },
        content: {
            // position: "absolute",
            // top: "100px",
            // left: "40px",
            // right: "40px",
            // height: "600px",
            // border: "1px solid #ccc",
            // background: "#fff",
            // overflow: "show",
            // WebkitOverflowScrolling: "touch",
            // borderRadius: "4px",
            // outline: "none",
            // padding: "20px",
        }
    };

    render = () => {
        const {
            dataList,
            showModalDataForm,
            showModalAccount,
            showModalCreateCompany,
            showModalInviteCompany,
            searchedCompany,
            viewState,
            companyType
        } = this.state;
        const {
            credentials
        } = this.props;

        moment.locale('de');
        const localizer = momentLocalizer(moment);

        const messages = {
            allDay: 'ganzer Tag',
            previous: '<',
            next: '>',
            today: 'heute',
            month: 'Monat',
            week: 'Woche',
            day: 'Tag',
            agenda: 'Agenda',
            date: 'Datum',
            time: 'Zeit',
            event: 'Ereignis',
            showMore: total => `+${total} Ereignisse`
        };
        // if (dataList.length === 0)
        //     return <React.Fragment></React.Fragment>;

        let view = Views.DAY
        switch (viewState) {
            case "week":
                view = Views.WEEK;
                break;
            case "workWeek":
                view = Views.WORK_WEEK;
                break;
            case "month":
                view = Views.MONTH;
                break;
            case "agemda":
                view = Views.AGENDA;
                break;
            case "day":
            case "dayPerLoadingPlace":
            case "dayWithOccupancyPerLoadingPlace":
            default:
                view = Views.DAY;
                break;

        }

        let createCompanyText = "";
        switch (companyType) {
            case this.RECEIVER:
                createCompanyText = "Empfänger";
                break;
            case this.VENDOR:
                createCompanyText = "Lieferant";
                break;
            case this.CARRIER:
                createCompanyText = "Spediteur";
                break;
        }

        const modalKey = new Date().getTime()
        return (
            <React.Fragment>
                <MobileLogisticsPlanningDataForm
                    credentials={credentials}
                    key={modalKey + 1}
                    showModal={showModalDataForm}
                    ariaHideApp={false}
                    style={this.MODAL_STYLES}
                    selectedLogicticsPlanningDbId={this.selectedLogicticsPlanningDbId}
                    selectedSlot={this.selectedSlot}
                    handleCancel={this.onCloseModal}
                    handleSave={this.onSaveLogisticsPlanning}
                    handleDelete={this.onDeleteLogisticsPlanning}
                    receiversMap={this.receiversMap}
                    receiverList={this.receiverList}
                    vendorsMap={this.vendorsMap}
                    vendorList={this.vendorList}
                    carriersMap={this.carriersMap}
                    carrierList={this.carrierList}
                    ressourcesMap={this.ressourcesMap}
                    ressourceList={this.ressourceList}
                    loadingPlacesMap={this.loadingPlacesMap}
                    loadingPlaceList={this.loadingPlaceList}
                    vehicleTypesMap={this.vehicleTypesMap}
                    vehicleTypeList={this.vehicleTypeList}
                />
                <MobileLogisticsPlanningCreateCompany
                    credentials={credentials}
                    key={modalKey + 2}
                    showModal={showModalCreateCompany}
                    companyType={companyType}
                    companyTypeText={createCompanyText}
                    ariaHideApp={false}
                    style={this.MODAL_STYLES}
                    handleCancel={this.onCloseModal}
                    handleSave={this.onSaveCreateCompany}
                />
                <MobileLogisticsPlanningAccount
                    credentials={credentials}
                    key={modalKey + 3}
                    showModal={showModalAccount}
                    companyType={companyType}
                    companyTypeText={createCompanyText}
                    ariaHideApp={false}
                    style={this.MODAL_STYLES}
                    handleCancel={this.onCloseModal}
                    handleSave={this.onSaveCreateCompany}
                />
                {!showModalDataForm && !showModalAccount && !showModalCreateCompany && !showModalInviteCompany && (

                    <Calendar
                        resources={
                            viewState === "dayPerLoadingPlace" || viewState === "dayWithOccupancyPerLoadingPlace" ?
                                this.calendarRessourceList :
                                null}
                        events={dataList}
                        // views={allViews}
                        localizer={localizer}
                        scrollToTime={new Date(1970, 1, 1, 6)}  //??
                        min={new Date(2020, 7, 28, 6)}
                        max={new Date(2020, 7, 28, 17)}
                        defaultDate={this.selectedDate}
                        defaultView={view}
                        startAccessor="start"
                        endAccessor="end"
                        step={30}
                        timeslots={2}
                        // dayPropGetter={this.customDayPropGetter}
                        // slotPropGetter={this.customSlotPropGetter}
                        eventPropGetter={this.customEventPropGetter}
                        style={{height: 900}}
                        components={{
                            event: this.renderEvent,
                            agenda: {
                                event: this.renderEventAgenda,
                            },
                            toolbar: (props) => {
                                const params = {
                                    viewState: viewState,
                                    handleRefresh: this.onRefresh,
                                    rolesMap: this.rolesMap,
                                    companyList: this.receiverList,
                                    // receiverList: this.receiverList,
                                    // vendorList: this.vendorList,
                                    // carrierList: this.carriererList,
                                    searchedCompany: searchedCompany,
                                    handleSearchCompany: this.onSearchCompany,
                                    handleDate: this.onDate,
                                    name: "Logistik",
                                    handleEditAccount: this.onEditAccount,
                                    handleCreateReceiver: this.onCreateReceiver,
                                    handleInviteReceiver: this.onInviteReceiver,
                                    handleCreateVendor: this.onCreateVendor,
                                    handleInviteVendor: this.onInviteVendor,
                                    handleCreateCarrier: this.onCreateCarrier,
                                    handleInviteCarrier: this.onInviteCarrier,
                                    ...props
                                };

                                return (<CalendarToolbar {...params}/>);
                            }
                        }}
                        // onView={this.onView}
                        // popup
                        selectable={!showModalDataForm && !showModalAccount && !showModalCreateCompany && !showModalInviteCompany}
                        onSelectEvent={event => this.onSelectEvent(event)}
                        onSelectSlot={this.onSelectSlot}
                        messages={messages}
                        rtl={false}
                        culture={"de"}

                    />

                )}
            </React.Fragment>
        );
    }
}

export default MobileLogisticsPlanningListForm;
